module.exports = __webpack_public_path__ + "img/login.e1a518c2.png";